module.exports = __webpack_public_path__ + "119477a9ebcd4fb76a455f46a93f70e9.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/uikit/assets/font/noto-sans-kr-v11-korean_latin-500.woff2
// module id = 458
// module chunks = 0